import { render } from "./NoticeArea.vue?vue&type=template&id=69b25782"
import script from "./NoticeArea.vue?vue&type=script&lang=js"
export * from "./NoticeArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__